import axios from "axios";
import { base_url } from "../config";

// Configurar timeout global para Axios
axios.defaults.timeout = 300000; // 5 minutos

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";


// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    // Log para debugging de respuestas exitosas
    console.log(`[API Response] ${response.config.method?.toUpperCase()} ${response.config.url}`, {
      status: response.status,
      dataSize: JSON.stringify(response.data).length
    });
    return response.data ? response.data : response;
  },
  function (error) {
    // Log detallado para debugging de errores
    console.error('[API Response Error]', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      statusText: error.response?.statusText,
      message: error.message,
      code: error.code,
      isTimeout: error.code === 'ECONNABORTED',
      requestTimeout: error.config?.timeout
    });

    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.response?.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = error.message || error;
    }
    return Promise.reject(message);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class ApiBackendClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${base_url.erp_backend}${url}?${queryString}`, params);
    } else {
      response = axios.get(`${base_url.erp_backend}${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data) => {
    if (data.tenantId) {
      return axios.post(`${base_url.erp_backend}${url}?tenantId=${data.tenantId}`, data);
    }
    return axios.post(`${base_url.erp_backend}${url}`, data);

  };

  /**
   * Sube archivo usando FormData
   */
  uploadFormData = (url, formData, params = {}) => {
    let queryString = '';

    if (Object.keys(params).length > 0) {
      const paramKeys = [];
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });
      queryString = '?' + paramKeys.join('&');
    }

    // Log específico para uploads de archivos
    console.log(`[File Upload] Starting upload to ${url}`, {
      hasFormData: formData instanceof FormData,
      params: params,
      timeout: 60000 // 60 segundos para uploads
    });

    return axios.post(`${base_url.erp_backend}${url}${queryString}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 60000 // 60 segundos específicamente para uploads
    });
  };

  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(`${base_url.erp_backend}${url}`, data);
  };

  put = (url, data) => {
    if (data.tenantId) {
      return axios.put(`${base_url.erp_backend}${url}?tenantId=${data.tenantId}`, data);
    }
    return axios.put(`${base_url.erp_backend}${url}`, data);
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(`${base_url.erp_backend}${url}`, { ...config });
  };
}

export { ApiBackendClient, setAuthorization };